export default "__VITE_ASSET__DFSS2VRH__"